import * as React from "react"
import { Pagination, Table } from "react-bootstrap"

import PropTypes from "prop-types"
import { Link } from "gatsby"

const TableComponent = ({ columns, data, paginationSize, routeLink, routeState, rowClickEvent }) => {
	let hidePagination = false;
  if (paginationSize === 0) {
    paginationSize = data.length
		hidePagination = true
  }

  const getDataInterval = n => data.slice(
      n * paginationSize,
      Math.min((n + 1) * paginationSize, data.length))

  const [page, setPage] = React.useState(0)
  const [selectedData, setSelectedData] = React.useState(getDataInterval(0))

  const maxPage = Math.ceil(data.length / paginationSize)

  const updatePage = (pageNum) => {
    if (pageNum < 0 || pageNum >= maxPage) return;
    setPage(pageNum)
    setSelectedData(getDataInterval(pageNum))
  }

  return (
    <>
		{!hidePagination &&
			<Pagination>
        <Pagination.First onClick={() => updatePage(0)} />
        <Pagination.Prev  onClick={() => updatePage(page - 1)} />

        {Array.from({ length: maxPage }, (_, index) => index).map(num => (
          <Pagination.Item
            key={num}
            active={page === num}
            onClick={() => updatePage(num)}
          >
            {num + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => updatePage(page + 1)} />
        <Pagination.Last onClick={() => updatePage(maxPage - 1)} />
			</Pagination>
		}

      <Table bordered hover>
        <thead>
          <tr>
            {columns.map(({ name, key }) => (
              <th key={key}>{name}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {selectedData.map((rowData, rowIndex) => (
            <tr
              key={`row-${rowIndex}`}
							onClick={() => rowData.isNonDataRow || rowClickEvent(rowData)}
            >
              {columns.map(({ key, delimeter }, index) => (
								<td key={`${key}-${index}`}>
									{rowData.isNonDataRow
										? key.split("|").map(k => rowData[k] || "").join(delimeter || "")
										: <Link to={routeLink(rowData)} state={routeState(rowData)}>
												{key.split("|").map(k => rowData[k] || "").join(delimeter || "")}
											</Link>
									}
								</td>
              ))}
            </tr>
          ))}
        </tbody>

      </Table>
    </>
  )
}

TableComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    key : PropTypes.string
  })),
  data: PropTypes.arrayOf(PropTypes.object),
  paginationSize: PropTypes.number,
  routeLink: PropTypes.func,
  routeState: PropTypes.func,
  rowClickEvent: PropTypes.func,
}

TableComponent.defaultProps = {
  columns: [],
  data: [],
  paginationSize: 0,
	routeLink: () => "/",
	routeState: () => ({}),
	rowClickEvent: () => {},
}

export default TableComponent
